import {message}from'@lemon-fe/kits';import {AxiosError}from'../node_modules/.pnpm/axios@1.13.5_patch_hash_b46544b594ad21f8cf1fd6b1c21d06810006f8470872e2c462779245b94c3b94/node_modules/axios/index.js';import {nanoid}from'nanoid';import {MARS_IDP_SERVER_PATH}from'@monorepo/shared';import {getToperDomain,getUuid}from'./utils.js';import errorMessage from'./error-message.js';import axios from'../node_modules/.pnpm/axios@1.13.5_patch_hash_b46544b594ad21f8cf1fd6b1c21d06810006f8470872e2c462779245b94c3b94/node_modules/axios/lib/axios.js';const COOKIE_EXPIRE_DAYS = 7;
const request = axios.create();
let isFreshing = false;
let requestQueue = [];
const showLoginExpiredModal = () => {
    if (window.onMarsAuthExpired) {
        window.onMarsAuthExpired();
        return;
    }
    window.logoutAndRedirect?.();
};
const isRefreshTokenLoginUrl = (url) => url.includes(`${MARS_IDP_SERVER_PATH}/login`) && url.includes('grant_type=refresh_token');
// 参数序列化函数，兼容 umi-request 的行为
// umi-request 会将数组转换为逗号分隔的字符串，例如 [1,2,3] -> "1,2,3"
const serializeParams = (params) => {
    if (!params || typeof params !== 'object') {
        return params;
    }
    const result = {};
    Object.keys(params).forEach((key) => {
        const value = params[key];
        // 跳过 null 和 undefined
        if (value === null || value === undefined) {
            return;
        }
        // 数组类型：转换为逗号分隔的字符串（兼容 umi-request）
        if (Array.isArray(value)) {
            if (value.length > 0) {
                // 过滤掉空值，然后转换为字符串
                const filtered = value.filter((item) => item !== null && item !== undefined && item !== '');
                if (filtered.length > 0) {
                    result[key] = filtered.join(',');
                }
            }
            return;
        }
        // 对象类型：递归处理（但 umi-request 通常不支持嵌套对象，这里保持原样）
        if (typeof value === 'object' && value.constructor === Object) {
            result[key] = value;
            return;
        }
        // 其他类型：直接赋值
        result[key] = value;
    });
    return result;
};
const HttpRequest = async (params) => {
    const { url, method = 'GET', data, options, params: forceParams, paramsSerializer, forceData, isTokenRetry, } = params;
    const baseUrl = window.MARS_BASE_CONFIG.MARS_BASE_URL;
    // 删除值为空字符串的无效字段
    let cleanData = data;
    if (Object.prototype.toString.call(data) === '[object Object]') {
        cleanData = { ...data };
        Object.keys(cleanData).forEach((key) => {
            if (cleanData[key] === '') {
                delete cleanData[key];
            }
        });
    }
    const currentLanguage = localStorage.getItem('MarsLanguage');
    // 构建axios配置
    const config = {
        method,
        paramsSerializer,
        headers: {
            'x-mars-operate-source': 'WEB_ADMIN',
            'Accept-Language': currentLanguage?.includes('en') ? 'en_US' : 'zh_CN',
        },
        options: {
            ...options,
            isTokenRetry,
            noTips: params.noTips,
        },
    };
    if (method === 'post' || method === 'put' || method === 'POST' || method === 'PUT') {
        config.data = cleanData;
    }
    else {
        // GET 请求：使用序列化函数处理参数，兼容 umi-request 的行为
        if (forceData) {
            config.data = forceData;
        }
        else {
            // 序列化参数：数组转字符串、处理 null/undefined、日期对象等
            // umi-request 会将数组转换为逗号分隔的字符串，例如 [1,2,3] -> "1,2,3"
            config.params = serializeParams(cleanData);
        }
    }
    // 强制以params形式传递（也需要序列化）
    if (forceParams) {
        config.params = serializeParams(forceParams);
    }
    return request(`${baseUrl}/${url}`, config);
};
const commonReqInterceptor = (config) => {
    const options = config.options || {};
    const url = config.url || '';
    const isTokenRetry = options?.isTokenRetry || false;
    let deviceId = window.getCookie('device_id');
    const accessToken = window.getCookie('access_token');
    const merchantId = window.getCookie('merchant_id');
    const operator = window.getCookie('user_operator');
    if (!deviceId) {
        deviceId = nanoid(32);
        window.setCookie('device_id', deviceId, 365, getToperDomain());
    }
    config.headers['Content-Type'] = 'application/json';
    if (!config?.data) {
        config.data = {};
    }
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    // 设置headers
    config.headers.set('x-mars-operator', operator ? encodeURI(operator) : '');
    config.headers.set('X-Mars-Device-Id', deviceId);
    if (merchantId) {
        config.headers.set('x-mars-merchant-id', merchantId);
    }
    // 优先使用传入的merchant_id
    if (options?.merchant_id) {
        config.headers.set('x-mars-merchant-id', options?.merchant_id);
    }
    // 登录接口不需要token
    if (accessToken && !url.includes(`${MARS_IDP_SERVER_PATH}/login`)) {
        config.headers.set('Authorization', `Bearer ${accessToken}`);
    }
    const traceId = `${getUuid()}-${window.version}`;
    if (traceId) {
        const finalTraceId = isTokenRetry ? `${traceId}-retry` : traceId;
        config.headers.set('x-mars-trace-id', finalTraceId);
    }
    const otelConfig = config;
    otelConfig.otlpVersion = String(window.version || '');
    otelConfig.otlpAppName = getCurrentAppName();
    otelConfig.otlpRequestName = `${String(config.method || 'GET').toUpperCase()} ${getTracePath(url)}`;
    return config;
};
function getCurrentAppName() {
    const pathname = window.location.pathname || '';
    const appSegment = pathname.split('/').filter(Boolean)[0];
    return appSegment || 'base-app';
}
function getTracePath(url) {
    try {
        if (/^https?:\/\//.test(url)) {
            return new URL(url).pathname;
        }
    }
    catch {
        // ignore
    }
    return url || '/';
}
function commonResInterceptor(res) {
    const { data } = res;
    const code = data.code || 0;
    if (typeof data === 'string') {
        return {
            code,
            data,
            success: () => data,
            isSuccess: () => true,
        };
    }
    return {
        ...data,
        code,
        isSuccess: () => true,
        success: () => data,
    };
}
const codeMaps = {
    400: '错误请求，服务器无法处理',
    401: '未授权，服务器拒绝访问',
    403: '禁止访问， 服务器拒绝请求',
    404: '服务器找不到请求或请求不存在',
    500: '服务器内部错误',
    502: '网关错误',
    503: '服务不可用，服务器暂时过载或维护',
    504: '网关超时',
};
const returnErrors = ({ code, isReturnAxiosError, newErr, errorData, }) => {
    if (isReturnAxiosError) {
        return Promise.reject(newErr);
    }
    else {
        return {
            isSuccess: () => false,
            isFail: () => true,
            code,
            error: errorData,
        };
    }
};
function errorHandler(err) {
    const { response, config } = err;
    const errorData = response?.data || {};
    const code = errorData.code || 0;
    const status = response?.status || 0;
    const options = config?.options || {};
    const noTips = options?.noTips;
    const isReturnAxiosError = options?.isReturnAxiosError;
    const requestWithOtel = err.request;
    const otlpTraceID = String(requestWithOtel?.otlpTraceID || '');
    if (requestWithOtel) {
        requestWithOtel.otlpTraceID = otlpTraceID;
    }
    const newErr = new AxiosError(err.message, err.code, err.config, err.request, response);
    Object.assign(newErr, err);
    // 处理401 token刷新
    if (status === 401) {
        const refreshToken = window.getCookie('refresh_token');
        const url = config?.url || '';
        const baseUrl = window.MARS_BASE_CONFIG.MARS_BASE_URL;
        const isLoginUrl = url.includes(`${MARS_IDP_SERVER_PATH}/login`);
        const isRefreshTokenRequest = isRefreshTokenLoginUrl(url);
        if (isRefreshTokenRequest) {
            showLoginExpiredModal();
            return Promise.reject(newErr);
        }
        if (refreshToken && !isLoginUrl) {
            if (!isFreshing) {
                isFreshing = true;
                const refreshURL = `${baseUrl}/${MARS_IDP_SERVER_PATH}/login?grant_type=refresh_token&client_id=${window.MARS_BASE_CONFIG.CLIENT_ID}&client_secret=${window.MARS_BASE_CONFIG.CLIENT_SECRET}&refresh_token=${refreshToken}`;
                request({
                    url: refreshURL,
                    method: 'POST',
                })
                    .then((result) => {
                    const { access_token, refresh_token } = result.data;
                    window.setCookie('access_token', access_token, COOKIE_EXPIRE_DAYS, getToperDomain());
                    window.setCookie('refresh_token', refresh_token, COOKIE_EXPIRE_DAYS, getToperDomain());
                    requestQueue.forEach((fn) => fn());
                })
                    .catch((error) => {
                    if (error?.response?.status === 401) {
                        showLoginExpiredModal();
                        requestQueue = [];
                        return;
                    }
                    console.log('logoutAndRedirect: refreshToken');
                    window.logoutAndRedirect && window.logoutAndRedirect();
                    requestQueue = [];
                })
                    .finally(() => {
                    isFreshing = false;
                    requestQueue = [];
                });
            }
            return new Promise((resolve, reject) => {
                requestQueue.push(() => {
                    // 重新发起原请求
                    if (config) {
                        request(config)
                            .then((res) => resolve(res))
                            .catch((error) => reject(error));
                    }
                    else {
                        reject(newErr);
                    }
                });
            });
        }
    }
    let errorMsg = '';
    // 处理错误数据
    if (errorData) {
        // 处理特定错误码
        if (errorData.errors) {
            if ([4000001, 50000001, 50000002, 50000003, 50000004, 50000005, 50000006, 50000007].includes(code)) {
                return returnErrors({ code, isReturnAxiosError, newErr, errorData });
            }
            if ([3000023, 3000025].includes(code)) {
                console.log('logoutAndRedirect', code);
                window.logoutAndRedirect?.();
                // 按照原逻辑直接RETURN掉
                return;
            }
            // 收集错误信息
            if (typeof errorData.errors === 'string') {
                errorMsg = errorData.errors;
            }
            else if (Array.isArray(errorData.errors)) {
                errorMsg = errorData.errors[0]?.message;
            }
            else {
                errorMsg = errorData.errors?.message;
            }
        }
        // 设置错误信息
        newErr.message = errorMsg || codeMaps[status] || '网络异常，请稍后再试';
    }
    else {
        newErr.message = '网络异常，请稍后再试';
    }
    // 显示错误提示（使用 JSX 组件）
    if (!noTips && newErr.message && !isReturnAxiosError) {
        message.error(errorMessage({ msg: newErr.message, traceId: otlpTraceID }));
    }
    return returnErrors({ code, isReturnAxiosError, newErr, errorData });
}
request.interceptors.request.use(commonReqInterceptor);
request.interceptors.response.use(commonResInterceptor, errorHandler);export{HttpRequest as default};//# sourceMappingURL=index.js.map
